<template>
  <div>
    <b-loading :is-full-page="true" :active="!initialized"></b-loading>
    <section v-if="initialized" class="section is-main-section">
      <CardComponent>
        <div class="section has-text-centered">
          <h1 class="title">
            Manage Package Titles:
            <router-link
              :to="{
                name: 'EditPackage',
                params: { id: package.id }
              }"
              >{{ package.title }}</router-link
            >
          </h1>
        </div>
        <div class="flex has-margin-bottom-30">
          <div class="columns is-centered">
            <div class="column">
              <b-field>
                <b-autocomplete
                  v-model="title"
                  placeholder="Select a title to add"
                  :data="filteredTitles"
                  field="title"
                  expanded
                  :open-on-focus="true"
                  @select="
                    value => {
                      if (value && value.id) {
                        selectedTitle = value.id
                      }
                    }
                  "
                >
                </b-autocomplete>
                <p class="control">
                  <b-button
                    type="is-primary"
                    :disabled="!selectedTitle"
                    @click="addTitle(selectedTitle)"
                    >Add</b-button
                  >
                </p>
              </b-field>
            </div>
          </div>
        </div>
        <div class="columns is-vcentered">
          <div class="column is-10 is-offset-1">
            <div class="flex-card light-bordered light-raised">
              <div class="card-body">
                <ValidationObserver ref="observer" v-slot="{ passes }">
                  <form @submit.prevent="passes(submit)">
                    <div>
                      <div v-if="items.length === 0" class="has-text-centered">
                        No items yet.
                      </div>
                      <div v-if="items.length > 0">
                        <div
                          class="columns has-text-left has-text-weight-bold is-hidden-mobile"
                          style="border-bottom: 1px solid #eee;"
                        >
                          <div class="column is-2"></div>
                          <div class="column is-5">Title</div>
                          <div class="column is-1"></div>
                        </div>
                        <div
                          v-for="item in selectedTitles"
                          :key="item.id"
                          class="columns is-vcentered"
                        >
                          <div class="column is-2">
                            <router-link
                              :to="{
                                name: 'MediaDetail',
                                params: { id: item.media_id }
                              }"
                            >
                              <figure v-if="getTitleImage(item)" class="image">
                                <img :src="getTitleImage(item)" />
                              </figure>
                            </router-link>
                          </div>
                          <div class="has-padding-left-15 column is-5">
                            <router-link
                              :to="{
                                name: 'MediaDetail',
                                params: { id: item.media_id }
                              }"
                            >
                              <h3 class="subtitle">{{ item.title }}</h3>
                            </router-link>
                          </div>
                          <div
                            class="has-padding-left-15 column is-1 is-hidden-desktop is-hidden-tablet"
                          >
                            <b-button
                              icon-left="close"
                              @click="confirmRemove(item.id)"
                              >Remove</b-button
                            >
                          </div>
                          <div
                            class="has-padding-left-15 column is-1 has-text-centered is-hidden-mobile"
                          >
                            <a href="" @click.prevent="confirmRemove(item.id)"
                              ><b-icon icon="close"></b-icon
                            ></a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </form>
                </ValidationObserver>
              </div>
            </div>
          </div>
        </div>
        <div class="has-text-centered">
          <b-button
            class="is-medium has-margin-right-10"
            tag="router-link"
            type="is-primary"
            :to="{
              name: 'EditPackage',
              params: {
                id: package.id
              }
            }"
          >
            Edit Package Details</b-button
          >
        </div>
      </CardComponent>
    </section>
    <b-modal
      :active.sync="showConfirmModal"
      trap-focus
      aria-role="dialog"
      aria-modal
      has-modal-card
      @close="showConfirmModal = false"
    >
      <div class="modal-card" style="width: auto">
        <header class="modal-card-head">
          <p class="modal-card-title">Confirm?</p>
        </header>
        <section class="modal-card-body">
          Are you sure you want to remove this title?
        </section>
        <footer class="modal-card-foot" style="justify-content: flex-end;">
          <button
            class="button"
            type="button"
            @click="showConfirmModal = false"
          >
            No
          </button>
          <button class="button is-primary" @click.prevent="remove()">
            Yes
          </button>
        </footer>
      </div>
    </b-modal>
  </div>
</template>

<script>
import CardComponent from '@/components/CardComponent'
import PackageApi from '@/api/packages'
import MediaApi from '@/api/media'
import Filters from '@/mixins/filters'
import Utils from '@/mixins/utils'

export default {
  name: 'ManagePackageTitles',
  components: {
    CardComponent
  },
  mixins: [Filters, Utils],
  metaInfo: {
    title: 'Manage Package Titles'
  },
  data() {
    return {
      initialized: false,
      loading: false,
      items: [],
      showConfirmModal: false,
      item: {},
      package: {},
      selectedTitle: null,
      titlesLookup: [],
      titles: [],
      title: ''
    }
  },
  computed: {
    selectedTitles() {
      if (this.items.length > 0) {
        return this.items.map(item => {
          return this.titles.find(title => title.id === item)
        })
      }
      return []
    },
    filteredTitles() {
      let filter = this.title.toLowerCase()
      if (this.items.length > 0 && this.titles.length > 0) {
        return this.titles.filter(
          item =>
            !this.items.includes(item.id) &&
            item.title.toLowerCase().includes(filter)
        )
      } else {
        return this.titles.filter(item =>
          item.title.toLowerCase().includes(filter)
        )
      }
    }
  },
  async created() {
    await this.fetch()
    let titles = await MediaApi.getAll()
    this.titlesLookup = titles
    this.titlesLookup.forEach(
      item =>
        (item.title = `${item.title} - ${this.$options.filters.capitalize(
          item.media_type
        )}`)
    )
    titles.forEach(title => (title.mediadata = JSON.parse(title.mediadata)))
    this.titles = titles
    this.initialized = true
  },
  methods: {
    async fetch() {
      this.package = await PackageApi.getById(this.$route.params.id)
      this.items = this.package.media_ids
        ? this.package.media_ids.split(',').map(item => parseInt(item, 10))
        : []
    },
    async addTitle(titleId) {
      if (!isNaN(titleId)) {
        this.items.push(titleId)
      }

      this.package.media_ids = this.items.join(',')
      await PackageApi.updateMediaIds(this.package)
    },
    getTitleImage(item) {
      return item.mediadata &&
        item.mediadata.titleImage &&
        item.mediadata.titleImage !== ''
        ? this.thumbnail(item.mediadata.titleImage)
        : null
    },
    confirmRemove(item) {
      this.showConfirmModal = true
      this.item = item
    },
    async remove() {
      this.items = this.items.filter(item => item !== this.item)
      this.package.media_ids = this.items.join(',')
      await PackageApi.updateMediaIds(this.package)
      this.showConfirmModal = false
    }
  }
}
</script>
